import { render, staticRenderFns } from "./CSalesFunnel.vue?vue&type=template&id=7895dafd&scoped=true"
import script from "./CSalesFunnel.vue?vue&type=script&lang=ts"
export * from "./CSalesFunnel.vue?vue&type=script&lang=ts"
import style0 from "./CSalesFunnel.vue?vue&type=style&index=0&id=7895dafd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895dafd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
